interface Props {
  url: string;
  status: number | string;
  statusText: string;
  data: any;
}

export class GetAddressesError extends Error {
  public source: string;
  public url: string;
  public status: number | string = 500;
  public statusText: string = "Internal Server Error";
  public data: any;
  public dd_fingerprint: string;

  constructor({ url, status, statusText, data }: Props) {
    super(`Failed to get addresses
      # url: ${url}
      # status: ${status}
      # statusText: ${statusText}
      # data: ${JSON.stringify(data, null, 2)}
    `);

    this.name = "GetAddressesError";
    this.source = "custom";
    this.url = url;
    this.status = status;
    this.statusText = statusText;
    this.data = data;
    this.dd_fingerprint = "MIE-get-addresses-error";
  }
}

export class AddressNotFoundError extends Error {
  public source: string;
  public url: string;
  public data: any;
  public dd_fingerprint: string;

  constructor({ url, search }: { url: string; search: string }) {
    super(`No addresses found for query "${search}"`);

    this.name = "AddressNotFoundError";
    this.source = "custom";
    this.url = url;
    this.data = { search };
    this.dd_fingerprint = "MIE-address-not-found-error";
  }
}
